import React from 'react';
import { BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import { Browse, SignIn, FilmDetailPage, Dashboard } from './pages';
import * as ROUTES from './constants/routes';
import { IsUserRedirect, ProtectedRoute } from './helpers/routes';
import { useAuthListener } from './hooks';

export function App() {
  const { user } = useAuthListener();

  return (
    <Router>
      <Switch>
        <ProtectedRoute user={user} path={ROUTES.HOME} exact>
          <Browse />
        </ProtectedRoute>
        <ProtectedRoute user={user} path={ROUTES.DASHBOARD} exact>
          <Dashboard />
        </ProtectedRoute>
        <IsUserRedirect user={user} loggedInPath={ROUTES.HOME} path={ROUTES.SIGN_IN} exact>
          <SignIn />
        </IsUserRedirect>
        <ProtectedRoute user={user} path={ROUTES.FILM_DETAIL} exact>
          <FilmDetailPage />
        </ProtectedRoute>
        <Redirect to={ROUTES.HOME} />
      </Switch>
    </Router>
  );
}
